<ng-container *ngIf="!sliderLoading; else sliderLoadingSkeleton">
	<ng-container *ngIf="portfolioTransformedData.length; else emptyTemplate">
		<div class="text-align-left padding-bottom-16">
			{{ selectedModelShortName }}
		</div>
		<ng-container *ngIf="portfolioTransformedData.length > 1; else oneModel">
			<dz-slider
				type="DEFAULT"
				[min]="min"
				[max]="max"
				[(ngModel)]="defaultValue"
				[defaultValue]="defaultValue"
				[customRangeLabelObject]="customRangeLabelObject"
				(sliderValueChangedEvent)="sliderValueChangeHandler($event)"
				[ngClass]="{
					conservative: selectedRiskProfileValue === RiskProfile.Conservative,
					moderate_conservative: selectedRiskProfileValue === RiskProfile.ModerateConservative,
					moderate: selectedRiskProfileValue === RiskProfile.Moderate,
					moderate_aggressive: selectedRiskProfileValue === RiskProfile.ModerateAggressive,
					aggressive: selectedRiskProfileValue === RiskProfile.Aggressive
				}"
				[microActionLinkEventName]="
					tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
					':' +
					tealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE +
					':mini compare slider'
				"
			></dz-slider>
		</ng-container>
		<ng-template #oneModel>
			<div
				class="risk-badge text-align-left"
				[ngClass]="{
					conservative: selectedRiskProfileValue === RiskProfile.Conservative,
					moderate_conservative: selectedRiskProfileValue === RiskProfile.ModerateConservative,
					moderate: selectedRiskProfileValue === RiskProfile.Moderate,
					moderate_aggressive: selectedRiskProfileValue === RiskProfile.ModerateAggressive,
					aggressive: selectedRiskProfileValue === RiskProfile.Aggressive
				}"
			>
				<span></span>
			</div>
		</ng-template>
	</ng-container>
</ng-container>
<ng-template #emptyTemplate>
	<span dcrHTMLKey="MODEL_SLIDER_NO_DATA">NO Data</span>
</ng-template>
<ng-template #sliderLoadingSkeleton>
	<ngx-skeleton-loader [theme]="{ 'border-radius': '0', height: '15px', 'margin-top': '32px' }"></ngx-skeleton-loader>
</ng-template>
